// src/components/admin/ForgotPassword.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const response = await fetch('https://demo-site.creativepulse.pk/demo-api/admin/forgot-password.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      
      const data = await response.json();
      
      if (data.success) {
        setSubmitted(true);
        toast.success(data.message);
      } else {
        toast.error(data.message || 'Failed to process request');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Connection error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="forgot-password-container">
        <div className="forgot-password-box">
          <div className="success-icon">✉️</div>
          <h2>Check Your Email</h2>
          <p>
            We've sent password reset instructions to <strong>{email}</strong>
          </p>
          <p className="text-muted">
            Please check your inbox and follow the link to reset your password.
            The link will expire in 1 hour.
          </p>
          <Link to="/admin/login" className="back-to-login">
            Back to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-box">
        <h2>Forgot Password?</h2>
        <p className="subtitle">
          Enter your registered email address and we'll send you a link to reset your password.
        </p>
        
        <form onSubmit={handleSubmit} className="forgot-form">
          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your registered email"
            />
          </div>
          
          <button type="submit" disabled={loading} className="reset-btn">
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>
        
        <div className="login-link">
          <Link to="/admin/login">← Back to Login</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;